import classnames from 'classnames'

/** Shared zebra + hover classes for SABER data tables (light and dark). */
export const TABLE_ROW_HOVER = 'hover:bg-slate-50 dark:hover:bg-slate-700/40'
export const TABLE_STRIPE_ROW_CLASS = 'bg-slate-100/70 dark:bg-slate-900/30'

/** Body row classes: hover, optional zebra on odd indices, plus any extras (cursor, etc.). */
export const tableBodyRowClass = (index: number, extra?: string): string =>
  classnames('transition-colors', TABLE_ROW_HOVER, index % 2 === 1 && TABLE_STRIPE_ROW_CLASS, extra)
